import { IpScale, IpScaleForm } from "pages/ip-scale/types";
import { api, providesList } from "api/baseApi";

const url = "/ip-scale";

export const { useGetIpScalesQuery, useCreateIpScaleMutation } = api
	.enhanceEndpoints({ addTagTypes: ["ip-scale"] })
	.injectEndpoints({
		endpoints: (build) => ({
			getIpScales: build.query<IpScale[], void>({
				query: () => url,
				providesTags: (result) => providesList(result, "ip-scale"),
			}),

			createIpScale: build.mutation<void, IpScaleForm>({
				query: (body) => ({
					url,
					method: "POST",
					body,
				}),
				invalidatesTags: (_, error) => (error ? [] : [{ type: "ip-scale", id: "LIST" }]),
			}),
		}),
	});
